import React, { useState, useEffect } from "react";

import styles from "./index.module.css";
import ReportTableQuestionnaire from "Reporting/Components/ReportTableQuestionnaire";
import { useQuestionnaireGet } from "./useQuestionnaireGet";
import Loader from "shared/Loader";

/*
 * Table displaying different items in a report using Diamond integration
 */
export default function ReportTableListQuestionnaire({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const [reports, setReports] = useState([]);
  const [sortedReportsByTitle, setSortedReportsByTitle] = useState({});

  const { data, isLoading, isError, refetch } = useQuestionnaireGet({
    events: filters.events,
  });

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (!data) return;

    const groupedReports = data.map((item) => ({
      title: item.reportName,
      reports: item.attendees,
      totals: item.totals,
    }));

    setReports(groupedReports);
    setReportsLength?.(groupedReports.length);
    setReportData?.(groupedReports);
  }, [data, setReportsLength, setReportData]);

  const handleSortedReportsChange = (title, sorted) => {
    setSortedReportsByTitle((prev) => ({ ...prev, [title]: sorted }));
  };

  useEffect(() => {
    if (reports.length === 0) return;
    const merged = reports.map((r) => ({
      ...r,
      reports: sortedReportsByTitle[r.title]
        ? sortedReportsByTitle[r.title]
        : r.reports,
    }));
    setReportData?.(merged);
  }, [sortedReportsByTitle, reports, setReportData]);

  if (isError) {
    return <div>Something went wrong...</div>;
  }
  if (isLoading) {
    return <Loader />;
  }
  if (reports.length === 0) {
    return <div>No Reports Found</div>;
  }

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <React.Fragment key={index}>
          <ReportTableQuestionnaire
            reports={report.reports}
            totals={report.totals}
            title={report.title}
            onSortedReportsChange={handleSortedReportsChange}
          />
        </React.Fragment>
      ))}
    </div>
  );
}
